import React from 'react'

function Loading() {
    return (
        <div className='w-12 h-12 border-4 border-gray-400/50 animate-spin border-l-transparent border-b-transparent rounded-full'></div>
    )
}

export default Loading